// extracted by mini-css-extract-plugin
export default {"coin_info_container":"CoinInfo_coin_info_container__9rfJJ","coin_info":"CoinInfo_coin_info__udJXp"};